function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnchecked = function SvgUnchecked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 18.889,
    height: 18.889,
    x: 2.556,
    y: 2.556,
    fill: "none",
    strokeWidth: 1.111,
    rx: 3.889,
    style: {
      stroke: "currentColor"
    }
  }));
};
export default SvgUnchecked;